<ng-container #outletLocation></ng-container>